import { ResendVerificationService } from './resend-verification.service';
import { VerifyEmailService } from './verify-email.service';

export * from './resend-verification.service';
export * from './verify-email.service'

export const SERVICES = [
  ResendVerificationService,
  VerifyEmailService,
];
